/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const capitalizePhrase = (value?: string | null): string => {
  if (!value) {
    return '';
  }

  return value
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .map((word) => {
      if (word.length === 0) {
        return '';
      }
      return word[0].toUpperCase() + word.substring(1);
    })
    .filter(Boolean)
    .join(' ');
};
